import { Component, Input } from '@angular/core';
import { PayrollSettingsService, Settings } from '@app/services/payroll-settings.service';
import { Subscription } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FeatureService } from '@app/services/feature.service';
import { FeatureFlag } from '@app/enums';

@Component({
    selector: 'journal-entry-report-settings-payroll-tax-form',
    templateUrl: './journal-entry-report-settings-payroll-tax-form.template.html',
})
export class JournalEntryReportSettingsPayrollTaxForm {
    journalEntryReportEmployerHealthTax: boolean;
    journalEntryReportWorkersCompensation: boolean;
    journalEntryReportCnesst: boolean;
    journalEntryReportQhsf: boolean;

    payrollSettings: Settings;
    payrollSettingsServiceSubscription$: Subscription;

    jerPayrollTaxes = false;
    constructor(
        private payrollSettingsService: PayrollSettingsService,
        private featureService: FeatureService
    ) {
        this.payrollSettingsServiceSubscription$ = this.payrollSettingsService.settings$
            .pipe(takeUntilDestroyed())
            .subscribe((settings) => {
                this.payrollSettings = settings;
                this.journalEntryReportEmployerHealthTax = this.payrollSettings.journalEntryReportEmployerHealthTax;
                this.journalEntryReportWorkersCompensation = this.payrollSettings.journalEntryReportWorkersCompensation;
                this.journalEntryReportCnesst = this.payrollSettings.journalEntryReportCnesst;
                this.journalEntryReportQhsf = this.payrollSettings.journalEntryReportQhsf;
            });
        this.featureService.has(FeatureFlag.jerPayrollTaxes).then((jerPayrollTaxes) => {
            this.jerPayrollTaxes = jerPayrollTaxes;
        });
        this.payrollSettingsService.load();
    }

    async toggleEht(event: boolean): Promise<void> {
        this.payrollSettings.journalEntryReportEmployerHealthTax = event;
        await this.payrollSettingsService.save();
    }
    async toggleWc(event: boolean): Promise<void> {
        this.payrollSettings.journalEntryReportWorkersCompensation = event;
        await this.payrollSettingsService.save();
    }
    async toggleCnesst(event: boolean): Promise<void> {
        this.payrollSettings.journalEntryReportCnesst = event;
        await this.payrollSettingsService.save();
    }
    async toggleQhsf(event: boolean): Promise<void> {
        this.payrollSettings.journalEntryReportQhsf = event;
        await this.payrollSettingsService.save();
    }
}
